export default __webpack_public_path__ + "media/color/req-0e178299.svg";